<template>
  <div>
    <app-header title="">
      <template v-slot:actions>
        <button
          type="button"
          class="btn btn-primary mt-2 mt-xl-0"
          v-c-modal:modal="{}"
        >
          <i class="far fa-plus"></i> SLA
        </button>
      </template>
    </app-header>

    <div class="container container-fluid mt-4 mb-4">
      <div class="row m-t-xl m-b-md">
        <div class="col-sm-6">
          <h1 class="title">Client SLA Usage</h1>
        </div>
        <div class="col-sm-6 text-end">
          <div class="vdp-datepicker-wrapper mb-3">
            <span class="btn btn-prev" @click="decreaseMonthScope()"
              ><i class="fa fa-chevron-left"></i
            ></span>
            <datepicker
              v-bind:value="monthScope"
              @input="selectedMonthScope"
              class="datepicker"
              :format="'MMMM'"
              input-class="btn"
            ></datepicker>
            <span class="btn btn-next" @click="increaseMonthScope()"
              ><i class="fa fa-chevron-right"></i
            ></span>
          </div>
        </div>
      </div>
      <!-- /.row -->
      <div class="row mb-4">
        <div class="col-md-6 col-xl-3 mb-3">
          <div class="card card-widget">
            <div class="card-body">
              <h3 class="widget-title">Active SLAs</h3>
              <div class="row">
                <div class="col-6 pointer">
                  <p class="text-muted small">Total Count</p>
                  <p class="lead strong">{{ active.length }}</p>
                </div>
                <div class="col-6 pointer">
                  <p class="text-muted small">Committed Hours</p>
                  <p class="lead strong">{{ totalComitted }}</p>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="col-md-6 col-xl-3 mb-3">
          <div class="card card-widget">
            <div class="card-body">
              <h3 class="widget-title">Extra Value</h3>
              <div class="row">
                <div class="col-6 pointer">
                  <p class="text-muted small">Service Value</p>
                  <p class="lead strong">{{ overviewData ? overviewData.data.service_value : '-' }}</p>
                </div>
                <div class="col-6 pointer">
                  <p class="text-muted small">Warranty</p>
                  <p class="lead strong">{{ overviewData ? overviewData.data.warranty : '-' }}</p>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="col-md-6 col-xl-3 mb-3">
          <div class="card card-widget">
            <div class="card-body">
              <h3 class="widget-title">Total Hours Spent</h3>
              <div class="row">
                <div class="col-12 pointer">
                  <p class="text-muted small">Support Developers</p>
                  <p class="lead strong">{{ overviewData ? overviewData.data.total : '-' }}</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <sla-ticket-breakdown
        v-if="monthScope"
        :start="momentMonthScope.startOf('month')"
        :end="momentMonthScope.endOf('month')"
      />

      <slas-list-filters v-model="params" />

      <c-data-list
        v-if="initialLoad"
        ref="dataList"
        class="list-data list-sla"
        :items="active"
      >
        <template v-slot:columns>
          <div class="col-auto"><span class="status" style="opacity:0;"></span></div>
          <div class="col-4">Client</div>
          <div class="col-2 d-none d-md-block">Allotted</div>
          <div class="col-2 d-none d-md-block">Usage</div>
          <div class="col-3">Progress</div>
        </template>
        <template v-slot:default="slotProps">
          <slas-list-item :sla="slotProps.item" :month-scope="monthScope" />
        </template>
      </c-data-list>

      <div v-if="waitingAcceptanceSLAs.length > 0" class="decorative-divider mt-4 mb-3"></div>
      <h2 v-if="waitingAcceptanceSLAs.length > 0" class="mb-3">Pending SLAs</h2>
      <c-data-list
        v-if="initialLoad"
        ref="dataList2"
        class="list-data list-sla"
        :items="waitingAcceptanceSLAs"
      >
        <template v-slot:default="slotProps">
          <slas-list-item :sla="slotProps.item" :pending="true" />
        </template>
      </c-data-list>

      <sla-form ref="modal" title="Create SLA" :sla="newSLA" mode="create" :contact-id="contactId" @created="onSlaCreated"></sla-form>
    </div>
  </div>
</template>

<script>
import Datepicker from "vuejs-datepicker";
import {
  Selectize,
  LaddaButton,
} from "components/form/input";
import SlasListFilters from "./SlasListFilters";

import SlasListItem from "components/slas/SlasListItem";
import SlaForm from "components/slas/SlaForm";
import { mapGetters, mapState, mapActions } from "vuex";
import { notify, http } from "utils";
import { user } from "mixins";
import Multiselect from "vue-multiselect";
import { sortBy, assign, isEqual } from "lodash";
import SlaTicketBreakdown from "components/misc/SlaTicketBreakdown";

export default {
  mixins: [user],

  components: {
    Datepicker,
    Selectize,
    LaddaButton,
    SlasListItem,
    SlaForm,
    Multiselect,
    SlasListFilters,
    SlaTicketBreakdown,
  },

  data: function () {
    return {
      monthScope: null,
      months: moment.months().map(function (month, index) {
        return { id: index + 1, text: month };
      }),
      params: {},
      initialLoad: false,
      overviewData: null,
      contactId: null,
      newSLA: { send_panda_quote: false },
    };
  },
  mounted() {
    this.$watch("params", async (params, oldParams) => {
      if (isEqual(params, oldParams)) {
        return
      }

      await this.getSLAs(
        assign({ focus: moment().format("YYYY-MM-D") }, params)
      )
    })

    this.$watch("monthScope", async (params, oldParams) => {
      if (isEqual(params, oldParams)) {
        return;
      }

      const response = await http.get('slas/overview?focus=' + this.momentMonthScope.format("YYYY-MM-D"))
      this.overviewData = response.data
    })

    this.getSLAs(this.params).then(() => {
      this.initialLoad = true;
    })

    this.monthScope = new Date()
  },
  created: function () {
    // this.getSLAs({ focus: moment().format('YYYY-MM-D') })
  },
  computed: {
    ...mapState("sla", ["slas"]),
    ...mapState("user", ["authorized"]),
    ...mapGetters("sla", ["activeSLAs", "waitingAcceptanceSLAs"]),

    active: function (slas) {
      return sortBy(
        this.activeSLAs.filter((sla) => {
          return this.momentMonthScope.isBetween(
            moment(sla.start_date),
            moment(sla.end_date)
          );
        }),
        (sla) => {
          if (this.params.sort === "name,asc") {
            return sla.client.company;
          }
        }
      );
    },

    totalComitted() {
      return this.active.reduce((a, sla) => a + (sla.monthly_hours || 0), 0);
    },

    momentMonthScope: {
      // getter
      get: function () {
        return moment(this.monthScope);
      },

      // setter
      set: function (newValue) {
        this.monthScope = new Date(newValue);
      },
    },
  },
  methods: {
    ...mapActions("sla", ["getSLAs", "addSLA"]),

    onSlaCreated() {
      this.getSLAs(this.params);
    },

    customLabel: function ({ name, email }) {
      return `${name} – ${email}`;
    },
    setSorting: function (value) {
      this.sort = value;
    },
    selectedDate: function (e) {
      this.newSLA.start_date = e;
    },
    selectedMonthScope: function (e) {
      this.monthScope = e;
      this.search();
    },
    classForPercentage(percentage, prepend) {
      if (percentage < 30) {
        return prepend + "-good";
      } else if (percentage < 70) {
        return prepend + "-low";
      } else {
        return prepend + "-danger";
      }
    },
    showMonth(e) {
      var start = moment(this.sla.start_date);
      momentMonthScope;
    },
    increaseMonthScope() {
      this.momentMonthScope = this.momentMonthScope.add(1, "months");
    },
    decreaseMonthScope() {
      this.momentMonthScope = this.momentMonthScope.subtract(1, "months");
    },
    search(e) {
      this.searching = true;

      this.getSLAs({
        focus: this.momentMonthScope.format("YYYY-MM-D"),
        search: encodeURIComponent(this.searchString),
        sort: encodeURIComponent(this.sort.id),
      })
        .then(() => {
          this.searching.false;
        })
        .catch(() => {
          this.searching = flase;
        });
    },
  },
};
</script>

<style>
.datepicker {
  display: inline-block;
}

.option__small {
  display: block;
  opacity: 0.4;
}

</style>
